import { useRef, useState } from "react"

export default function FormInput({ id, label, type, placeholder, value, setText, direction="rtl", hasButton, buttonID=null, buttonText=null, buttonAction=null, resetText=null, hasMin=null, min=null, hasInfo=false, infoContent=null}) {

  const inputRef = useRef(null);
  const [showInfo, setShowInfo] = useState(false);
  return (
    <div className={hasButton ? "formInputBtn" : "formInput"}>
        <div className="form_infoDiv">
          {hasInfo ? <div className="form_info" onMouseEnter={()=>{setShowInfo(true)}} onMouseLeave={()=>{setShowInfo(false)}}>
            ?
            {showInfo ? <div className="form_infoContent">{infoContent}</div> : null}
          </div> : null}
        </div>
        <label htmlFor={id}>{label}</label>
        {hasButton ? 
          <div className="inputBtn_div">
            <input dir={direction} ref={inputRef} id={id} type={type} placeholder={placeholder} onChange={(e)=>{setText(e.target.value)}} min={hasMin && min()} maxLength={hasMin && 19 } value={value}/>
            <button id={buttonID}onClick={()=>{buttonAction(); if(resetText){inputRef.current.value = "";}}}>{buttonText}</button>
          </div> : 
          <input dir={direction} ref={inputRef} id={id} type={type} placeholder={placeholder} onChange={(e)=>{setText(e.target.value)}} min={hasMin && min()} maxLength={hasMin && 19} value={value}/>
        }
    </div>
  )
}
